import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "..";

const getAllRatings = async () => {

    const ratings = []

    const today = Date.now()
    // const year = today.getFullYear()
    // const month = today.getMonth() + 1
    // const day = today.getDate()
    // const currentDate = year + "/" + month + "/" + day
    const q = query(collection(db, "rating"));


    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
            ratings.push({ id: doc.id, ...doc.data() })
    });
    return ratings
}

export default getAllRatings